<template>
    <div class="main-container">
        <div class="landing-container">
            <component
                :is="component"
                v-for="component in myJson"
                :key="component" />
        </div>
    </div>
</template>

<script>
import HeaderLanding from '@/components/HeaderLanding.vue'
import FooterLanding from '@/components/FooterLanding.vue'
import TopInfos from '@/components/TopInfos.vue'
import Banner from '@/components/Banner.vue'
import Branding from '@/components/Branding.vue'
import Images from '@/components/Images.vue'
import Videos from '@/components/Videos.vue'
import Fullkit from '@/components/Fullkit.vue'
import AboutUs from '@/components/AboutUs.vue'
import News from '@/components/News.vue'
import json from '@/static/json/components.json'
export default {
    name: 'Landing',
    components: {
        HeaderLanding,
        Banner,
        FooterLanding,
        TopInfos,
        Branding,
        Images,
        Videos,
        Fullkit,
        AboutUs,
        News
    },
    data () {
        return { myJson: json[this.$route.name] }
    }
}
</script>
